import { render, staticRenderFns } from "./ftTabs.vue?vue&type=template&id=9edfeb0e&scoped=true&"
import script from "./ftTabs.vue?vue&type=script&lang=js&"
export * from "./ftTabs.vue?vue&type=script&lang=js&"
import style0 from "./ftTabs.vue?vue&type=style&index=0&id=9edfeb0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edfeb0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
